import AllImg from './img/All.png';
import BugImg from './img/bug.png';
import FishImg from './img/fish.png';
import SeaImg from './img/sea.png';

function Menu({ selectedCategory, onCategoryChange }) {
  return (
    <div className="menu">
      <button 
        className={`btn ${selectedCategory === 'all' ? 'active' : ''}`}
        onClick={() => onCategoryChange('all')}
      >
        <img src={AllImg} alt="All" />
      </button>
      <button 
        className={`btn ${selectedCategory === 'bug' ? 'active' : ''}`}
        onClick={() => onCategoryChange('bug')}
      >
        <img src={BugImg} alt="Bug" />
      </button>
      <button 
        className={`btn ${selectedCategory === 'fish' ? 'active' : ''}`}
        onClick={() => onCategoryChange('fish')}
      >
        <img src={FishImg} alt="Fish" />
      </button>
      <button 
        className={`btn ${selectedCategory === 'sea' ? 'active' : ''}`}
        onClick={() => onCategoryChange('sea')}
      >
        <img src={SeaImg} alt="Sea" />
      </button>
    </div>
  );
}
export default Menu;